import { TIME_RANGES, TypeDuration } from '../../constants/TimeRange';

const isDurationValid = (duration: undefined | TypeDuration): boolean =>
  duration !== undefined && TIME_RANGES.some(({ value }) => value === duration);

export default isDurationValid;
